<div id="gtinDialog" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;position:absolute !important" appDraggable dragTarget="#gtinDialog" dragHandle="#gtinDialogHeader">
  <div class="modal-content">
    <div class="modal-header" id="gtinDialogHeader" *ngIf = "addType =='IMPORT'">
		Import From File
    </div>
	<div class="modal-header" id="gtinDialogHeader" *ngIf = "addType !='IMPORT'">
		ADD NEW GTIN Validation Set
    </div>

    <div class="modal-body internal-well">
		<div class="form-group" >
			<div class="row">
				<div class="col-sm-2"><label for="name" class="labelRequired">NAME: </label></div>
				<div class="col-sm-5"><input class="form-control" type="text" [(ngModel)]="name" [disabled]="isUiDisabled" [readonly]="isUiDisabled"/></div>
			</div>
		</div>
		
		<br>
		
		<div class="row" *ngIf = "addType =='IMPORT'">
			<div class="col-sm-2">
				<label for="name" class="labelRequired">IMPORT FILE: </label>
			</div>
			<div class="col-sm-5">
				<input #typeFileUpload type="file" accept=".csv" [(ngModel)]="csvFile" (change)="onTypeFileUploadChange($event)" [disabled]="isUiDisabled" [readonly]="isUiDisabled" />
			</div>
		</div>
	</div>

    <div class="modal-footer">
		<button type="button" class="btn btn-default" (click)="onCancelClicked()" [disabled]="isUiDisabled"><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
		<button type="button" *ngIf = "addType =='IMPORT'" class="btn btn-primary" (click)="onOkClicked()" [disabled]="isUiDisabled"><i class="fa fa-ban" aria-hidden="true"></i> OK</button>
		<button type="button" *ngIf = "addType =='ADD'" class="btn btn-primary" (click)="onAddSetClicked()" [disabled]="isUiDisabled"><i class="fa fa-ban" aria-hidden="true"></i> OK</button>
    </div>
	
  </div>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
